export var COMPACT_OPTIONS = {
  compactDisplay: 'short',
  notation: 'compact'
};
export var DOLLAR_OPTIONS = {
  style: 'currency',
  currency: 'USD'
};
export var FALLBACKS = {
  DASHES: 'dashes',
  EMPTY: 'empty',
  ZERO: 'zero'
};
export var FORMATS = {
  NUMBER: 'number',
  DOLLAR: 'dollar',
  PERCENT: 'percent'
};
export var FALLBACK_STRINGS = {
  [FALLBACKS.DASHES]: String.fromCharCode(8208, 8208),
  [FALLBACKS.EMPTY]: ''
};
export var IF_ALL_DECIMAL_ZEROS = {
  FLOAT: 'float',
  INTEGER: 'integer'
};
export var OPTION_DEFAULTS = {
  compact: false,
  decimals: 2,
  format: FORMATS.NUMBER,
  ifInvalid: FALLBACKS.DASHES,
  ifAllDecimalZeros: IF_ALL_DECIMAL_ZEROS.INTEGER,
  ifZero: FALLBACKS.ZERO
};
export var PERCENT_OPTIONS = {
  style: 'percent'
};
export var STORY_DATA_NEGATIVE = [-123456789, -12345678.9, -1234567.89, -123456.789, -12345.6789, -1234.56789, -123.456789, -12.3456789, -1.23456789, -1, -0.123456789, -0.0123456789, -0.00123456789];
export var STORY_DATA_POSITIVE = [123456789, 12345678.9, 1234567.89, 123456.789, 12345.6789, 1234.56789, 123.456789, 12.3456789, 1.23456789, 1, 0.123456789, 0.0123456789, 0.00123456789];
export var STORY_DATA_PERCENT_POSITIVE = [12.3456789, 1.23456789, 0.123456789, 0.0123456789, 0.00123456789, 0.000123456789, 0.0000123456789];
export var STORY_DATA_PERCENT_NEGATIVE = [-12.3456789, -1.23456789, -0.123456789, -0.0123456789, -0.00123456789, -0.000123456789, -0.0000123456789];